
import { useRef, useEffect, useState } from "react";
import { useFadeInOnScroll } from "../../utils/HomePageFadeEffects";

function CountUp({ end, duration = 2000, isVisible, showPlus = false }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const increment = end / (duration / 16); // approx 60fps
    let animationFrame;

    const step = () => {
      start += increment;
      if (start >= end) {
        setCount(end);
        cancelAnimationFrame(animationFrame);
      } else {
        setCount(Math.floor(start));
        animationFrame = requestAnimationFrame(step);
      }
    };

    animationFrame = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration, isVisible]);

  return <span className="text-2xl sm:text-3xl font-bold text-sky-600">{count} {count === end && showPlus && "+"} </span>;
}

export default function StatsBlock() {
  const [ref, isVisible] = useFadeInOnScroll();

  const stats = [
    { label: "Avg. Response", value: "15 min" },
    { label: "Emergencies served", value: 5000, isCount: true, showPlus: true },
    { label: "Hospitals partnered", value: 50, isCount: true, showPlus: true },
  ];

  return (
    <section
      ref={ref}
      className={`w-full py-8 rounded-xl shadow-lg border bg-gradient-to-br from-sky-50 via-white to-sky-100 relative overflow-hidden stats-fadein${isVisible ? ' visible' : ''}`}
      aria-label="Madeshwara Ambulance Statistics"
    >
      <div className="max-w-2xl mx-auto px-1 sm:px-4">
        <p className="text-lg md:text-xl font-semibold text-sky-900 mb-6 max-w-2xl mx-auto text-center">
          Choose assurance when it matters most. <span className="text-sky-600 font-bold">Madeshwara Ambulance</span> delivers rapid medical support—trusted by <span className="text-amber-500 font-bold">thousands of families</span> and healthcare leaders.<br />
          <span className="text-gray-700">Every response, every transfer, every life matters.</span>
        </p>
      </div>

      <dl className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8 px-2 relative z-10">
        {stats.map((stat, index) => (
          <div key={index} className="rounded-xl bg-white bg-opacity-90 p-4 shadow text-center min-w-[100px] sm:min-w-[120px]">
            <dt className="sr-only">{stat.label}</dt>
            <dd>
              {stat.isCount ? <CountUp end={stat.value} isVisible={isVisible} showPlus={stat.showPlus} /> : <span className="text-2xl sm:text-3xl font-bold text-sky-600">{stat.value}</span>}
              <div className="text-gray-700 text-sm sm:text-base">{stat.label}</div>
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
